import { useState } from "react";

export interface IResetNodeManager {
    addResetCallback: (node: IResetCallback) => void;
    removeResetCallback: (node: IResetCallback) => void;
}

type IResetCallback = () => void;

/** Взять и мониторить состояние через props.currentValue у каждой ноды нельзя. при 30+ открытых элементов в справочнике
 * Начинаются дикие тормоза.
 * Этот хук призван сгладить тормоза
 * */
export const useResetNodesStateCallbacks = (): {
    resetStateForAllNodes: () => void;
    resetNodeStateManager: IResetNodeManager;
} => {
    const [resetCallbacks, setResetCallbacks] = useState<IResetCallback[]>([]);
    const addResetCallback = (node: IResetCallback) => {
        setResetCallbacks(prev => {
            if (!prev.includes(node)) {
                return [...prev, node];
            }
            return [...prev];
        });
    };

    const removeResetCallback = (node: IResetCallback) => {
        setResetCallbacks(prev => prev.filter(prevNode => prevNode !== node));
    };

    const resetStateForAllNodes = () => {
        resetCallbacks.forEach(resetCallback => resetCallback());
    };

    return {
        resetNodeStateManager: { addResetCallback: addResetCallback, removeResetCallback: removeResetCallback },
        resetStateForAllNodes: resetStateForAllNodes,
    };
};
